var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13636 15.3127C9.41909 15.3127 10.4545 14.2772 10.4545 12.9945C10.4545 11.7118 9.41909 10.6763 8.13636 10.6763C6.85364 10.6763 5.81818 11.7118 5.81818 12.9945C5.81818 14.2772 6.85364 15.3127 8.13636 15.3127ZM17.4091 10.6763H11.2273V16.0854H5.04545V9.13086H3.5V20.7218H5.04545V18.4036H18.9545V20.7218H20.5V13.7672C20.5 12.0595 19.1168 10.6763 17.4091 10.6763Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2028 4.27688C18.2028 5.40468 17.2959 6.31156 16.1681 6.31156C15.0403 6.31156 14.1334 5.40468 14.1334 4.27688C14.1334 3.14908 15.0403 2.24219 16.1681 2.24219C17.2959 2.24219 18.2028 3.14908 18.2028 4.27688Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3374 19.4036V20.926H15.0055V19.4036H17.3374Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 10.8742V15.1126H17.3374V18.4036H15.0055V15.1126H13.8428V10.6763H17.4091C17.7932 10.6763 18.1609 10.7463 18.5001 10.8742Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4994 9.8231C18.4686 8.5704 17.4345 7.55517 16.1747 7.55517H16.1681C14.958 7.55517 13.956 8.49205 13.8517 9.67631H17.4091C17.7867 9.67631 18.1523 9.72742 18.4994 9.8231Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/Visitor.f9ebe74a78d54116f2956f1de2637ecc.svg";
export { ForwardRef as ReactComponent };